<script>
    import CardLayout from "../../../../Components/Common/CardLayout.svelte";
    export let patientDetails = {};
    export let patientEncounterDetails = {};

</script>

<CardLayout title="Other Details" headerClass="card-layout-empty-header" cardClass="!border-0 pl-4 pr-4" enableCollapse={false}>
    <div class="flex flex-row gap-x-2">
        <!-- patient bad debtor -->
        <div class="form-control w-full flex flex-row items-center gap-x-2">
            <p class="title">Patient UR Number: </p>
            <input
                type="text"
                id="URNumber"
                class="input w-remaining input-sm input-bordered"
                autocomplete="off"
                placeholder="UR Number"
                bind:value={patientDetails.urNumber}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "UR Number";
                }}
            />
        </div>
        <div class="flex items-center gap-x-4 w-full px-2">
            <input
                type="checkbox"
                id="badDebtorCheckbox"
                class="toggle toggle-secondary"
                autocomplete="off"
                bind:checked={patientDetails.badDebtor}
            />
            <label for="badDebtorCheckbox" class="cursor-pointer">
                Patient is Bad Debtor
            </label>
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 200px;
    }

    .w-remaining {
        width: calc(100% - 200px);
    }
</style>
